import { DataBean } from "../DataBean";

export class ImportDeclaration extends DataBean {

    public async updateImportDeclaration(bean: any): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.orange.finance.processcontract.bean.ImportDeclaration_updateImportDeclaration_com.orange.finance.processcontract.bean.ImportDeclaration",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.finance.processcontract.bean.ImportDeclaration"
                }
            ]
        );
    }

}